import styled from '@emotion/styled';
import { Paper } from '@mui/material';

const CustomPaper = styled(Paper)({ borderRadius: 20 });

export default CustomPaper;
